import React from "react";

class Speaker1 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
    };
  }

  componentDidMount() {
    document.title =
      "Keynote Speakers - Conference on Advanced Artificial Intelligence and Education (CAAIE)";
  }

  render() {
    const { data } = this.state;
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <div className="section_title_container text-center">
                  <div className="section_title">
                    <h1>Keynote Speaker</h1>
                  </div>
                </div>
                <div className="intro_text text-center">
                  <div className="row speakers_row">
                    <div className="col-xl-12 col-md-12">
                      <img
                        src={require("../assets/img-comm/ahmed.png")}
                        alt=""
                        width="215"
                        height="240"
                      />
                      <h4>Professor Ahmed Seffah </h4>

                      <div className="organiser_intro mt-2 col-md-12">
                        <div className="col-md-12">
                          <p align="center">
                            <i>
                              Full Professor, College of Technological
                              Innovation, Zayed University, Abu Dhabi, UAE
                            </i>
                          </p>
                        </div>
                      </div>
                      <br></br>
                      <div className="intro_left_content text_left">
                        <p align="left">
                          Ahmed Seffah is a Full Professor at the College of
                          Technological Innovation, Zayed University, Abu Dhabi,
                          and co-founder of the Symbio Living Lab (Human-Centric
                          AI | Genuine Sustainability,
                          www.symbiolivinglab.info). He holds prior full
                          professorships at Concordia University (Canada) and
                          Lappeenranta University (Finland). He has served as a
                          Distinguished Visiting Scholar in California and as a
                          Principal Investigator at the Computer Research
                          Institute of Montreal.
                        </p>
                        <p align="left">
                          A pioneering researcher in Human-Centered Software
                          Engineering, a term he coined in 2001, Professor
                          Seffah's research spans Human-Centric AI Systems
                          Engineering, Human-AI Interaction, and
                          Social-Cyber-Physical Systems Modeling, with sustained
                          application to sustainability challenges aligned with
                          the UN SDGs. Over a 35-year academic career, he has
                          authored 8 books and more than 200 publications in
                          leading HCI, design science, and software engineering
                          venues. He has supervised 20 PhD students and over 50
                          master's students, many of whom are now academic
                          faculty or industry leaders at organizations including
                          IBM, SAP, Bombardier, and Oracle. He has established
                          research labs in three countries and contributed to
                          the design and accreditation of more than 15 academic
                          programs, including two PhD programs and three
                          interdisciplinary master's programs bridging
                          Human-Computer Interaction and Software Engineering.
                          His work has been recognized with research and
                          teaching excellence awards from NSERC and CFI
                          (Canada), the Academy of Science Finland, and industry
                          partners including SAP, Daimler/Mercedes, and
                          Bombardier. Beyond academia, he has worked as a
                          humanitarian volunteer, helping educational
                          institutions design sustainability-focused curricula
                          through design thinking and transition design.
                        </p>
                        <h4>
                          Keynote: AI-Enabled Research 2.0 From Lab to Practice
                        </h4>
                        <p align="left">
                          Artificial Intelligence has moved from a peripheral
                          productivity aid to a transformative co-researcher,
                          fundamentally reshaping how scholars conceive, design,
                          and execute academic inquiry. This keynote presents
                          the framework behind AI-Enabled Research 2.0: From Lab
                          to Practice, a methodology developed and empirically
                          validated over two years within the Symbio Living Lab
                          at Zayed University. Rather than treating AI adoption
                          as an ad-hoc collection of productivity hacks, the
                          talk introduces a structured, lab-based approach
                          spanning the full academic research lifecycle, from
                          systematic literature reviews and qualitative coding
                          to rapid prototyping, experimental design, and
                          scholarly writing. Grounded in the philosophy of
                          education by research, the framework was stress-tested
                          across graduate research methods courses,
                          undergraduate capstones, and advanced projects in
                          Human-Computer Interaction, cybersecurity, AI systems
                          engineering, and sustainability science. The talk will
                          walk through the eight core laboratories that
                          de-friction high-cost academic tasks and will present
                          the accompanying ethical framework, grounded in
                          international standards such as ALTAI and UNESCO's AI
                          Ethics recommendations. It positions AI not as a
                          shortcut but as a rigorous, generative instrument of
                          scholarly inquiry. Beyond methodology, the
                          presentation addresses a structural gap in current
                          discourse: most existing guidance on AI in research is
                          either tool-specific and quickly dated or theoretical,
                          lacking field validation. It documents real
                          deployments across disciplines and institutional
                          contexts, including underrepresented research
                          ecosystems in the Global South. This talk offers
                          researchers, graduate students, and educators a
                          durable, tool-agnostic path from passive AI
                          consumption to reflective, ethically grounded
                          knowledge production using AI tools in research and
                          projects.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Speaker1;
